import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";

// STATE AND STORE
// LIBS
import API from "../../api";
import Model from "../../models/filials";
import validateForm from "../../lib/helpers/validateForm";
import { getDateFormat } from "../../lib/helpers/dates";

// UI
import {
  Alerts,
  Box,
  Button,
  Input,
  HeaderPage,
  Row,
  Col,
  ButtonGroup
} from "../../ui";

class FilialMoneyEditPage extends Component {
  state = {
    titleHeader: "Изменение операции с кассой",
    money: {},
    form: {
      sum: {
        value: "0",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.money.sum
      },
      created_at: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.money.created_at
      }
    },
    buttons: {
      save: {
        disabled: false,
        title: "Изменить операцию"
      }
    },
    redirect: {
      is: false,
      link: ""
    }
  };

  async componentDidMount() {
    const { id, moneyId } = this.props.match.params;
    const money = await API.filials.getOneMoneyOperation(moneyId);

    if (money && money._options) {
      const { form, redirect } = this.state;

      // Формируем redirect
      redirect.link = `/filials/${id}`;

      // Заполняем форму
      for (let key in form) {
        if (key === "sum") {
          form[key].value = String(money._options.sum) || "0";
        } else {
          if (form[key].isNumber) {
            form[key].value = String(money[key]) || "0";
          } else if (form[key].isDate) {
            form[key].value = getDateFormat(money[key]);
          } else {
            form[key].value = money[key] || "";
          }
        }
      }

      this.setState({ money, form, redirect });
    }
  }

  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { form } = this.state;

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value) || "";
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleDatepicker = (name, value) => {
    console.log("handleDatepicker in page:", name, value);

    this.setState(prevState => {
      return {
        form: {
          ...prevState.form,
          [name]: {
            ...prevState.form[name],
            value,
            isEdited: true,
            isError: false,
            errors: []
          }
        }
      };
    });
  };

  handleFormSubmit = async e => {
    e.preventDefault();

    const result = validateForm(this.state.form);

    this.setState({
      form: result.form
    });

    // Success
    if (result.valid) {
      const { save } = this.state.buttons;
      save.disabled = true;

      // Отключаем кнопку
      this.setState(prevState => {
        return {
          buttons: { ...prevState.buttons, save }
        };
      });

      save.disabled = false;

      const { form } = this.state;
      const { moneyId } = this.props.match.params;
      const optionsRequest = {};

      for (let nameItem in form) {
        if (form[nameItem].isEdited) {
          optionsRequest[nameItem] = form[nameItem].value;
        }
      }

      // Есть изменения?
      if (Object.keys(optionsRequest).length) {
        // Изменение текущего
        const resultUpdated = await API.filials.editOneMoneyOperation(moneyId, {
          ...optionsRequest
        });

        if (resultUpdated) {
          Alerts.success("Операция изменёна");

          // Включаем кнопку, данные сохранились
          this.setState(prevState => {
            return {
              redirect: { ...prevState.redirect, is: true },
              buttons: { ...prevState.buttons, save }
            };
          });
        } else {
          Alerts.error("Операция не изменёна");

          // Включаем кнопку, данные не сохранились
          this.setState(prevState => {
            return {
              buttons: { ...prevState.buttons, save }
            };
          });
        }
      } else {
        Alerts.alert("В операции нет изменений");

        // Включаем кнопку, данные не сохранились
        this.setState(prevState => {
          return {
            redirect: { ...prevState.redirect, is: true },
            buttons: { ...prevState.buttons, save }
          };
        });
      }
    }
  };

  render() {
    if (this.state.redirect.is) {
      return <Redirect to={this.state.redirect.link} />;
    } else {
      return (
        <div className="short">
          <Helmet>
            <title>{this.state.titleHeader}</title>
          </Helmet>

          <form className="form" onSubmit={this.handleFormSubmit}>
            <HeaderPage
              title={this.state.titleHeader}
              back={this.props.history.goBack}
            >
              <ButtonGroup>
                <Button
                  type="submit"
                  theme="success"
                  disabled={this.state.buttons.save.disabled}
                >
                  {this.state.buttons.save.title}
                </Button>
                <Button
                  type="button"
                  onClick={() => this.props.history.goBack()}
                  theme="default"
                >
                  Отмена
                </Button>
              </ButtonGroup>
            </HeaderPage>

            <Box>
              <Row>
                <Col padding="no-top-left">
                  <Input
                    label="Дата операции:"
                    name="created_at"
                    type="date"
                    value={this.state.form.created_at.value}
                    errors={this.state.form.created_at.errors}
                    handleChange={this.handleInput}
                    handleChangeDate={this.handleDatepicker}
                  />
                </Col>

                <Col padding="no-top-left">
                  <Input
                    label="Сумма:"
                    name="sum"
                    type="number"
                    value={this.state.form.sum.value}
                    errors={this.state.form.sum.errors}
                    handleChange={this.handleInput}
                  />
                </Col>
                <Col padding="no-top" />
                <Col padding="no-top" />
                <Col padding="no-top-right" />
              </Row>
            </Box>
          </form>
        </div>
      );
    }
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(FilialMoneyEditPage));
